import { Observable } from 'rxjs';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

export const toggleAdvisory = (dataDestService: any, componentDataSourceService: ComponentDataSourceService) => {
  return (adviId: number): Observable<any> => {
    
    return dataDestService.http.put(
      `${environment.apiUrl}/advi/${adviId}`,
      {}
    );
  };
};
